var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E0F2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.9994V19.3327M14.3333 13.9994V19.3327M17.6667 13.9994V19.3327M20.6667 13.9994V19.3327M10 20.3994L10 20.9327C10 21.3061 10 21.4927 10.0727 21.6354C10.1366 21.7608 10.2386 21.8628 10.364 21.9267C10.5066 21.9994 10.6933 21.9994 11.0667 21.9994H20.9333C21.3067 21.9994 21.4934 21.9994 21.636 21.9267C21.7614 21.8628 21.8634 21.7608 21.9273 21.6354C22 21.4927 22 21.3061 22 20.9327V20.3994C22 20.026 22 19.8393 21.9273 19.6967C21.8634 19.5713 21.7614 19.4693 21.636 19.4054C21.4934 19.3327 21.3067 19.3327 20.9333 19.3327H11.0667C10.6933 19.3327 10.5066 19.3327 10.364 19.4054C10.2386 19.4693 10.1366 19.5713 10.0727 19.6967C10 19.8393 10 20.026 10 20.3994ZM15.7686 10.0508L10.8353 11.1471C10.5372 11.2133 10.3882 11.2464 10.277 11.3266C10.1789 11.3973 10.1018 11.4933 10.0541 11.6044C10 11.7304 10 11.883 10 12.1883L10 12.9327C10 13.3061 10 13.4927 10.0727 13.6354C10.1366 13.7608 10.2386 13.8628 10.364 13.9267C10.5066 13.9994 10.6933 13.9994 11.0667 13.9994H20.9333C21.3067 13.9994 21.4934 13.9994 21.636 13.9267C21.7614 13.8628 21.8634 13.7608 21.9273 13.6354C22 13.4927 22 13.3061 22 12.9327V12.1883C22 11.883 22 11.7304 21.9459 11.6044C21.8982 11.4933 21.8211 11.3973 21.723 11.3266C21.6118 11.2464 21.4628 11.2133 21.1647 11.1471L16.2314 10.0508C16.145 10.0316 16.1019 10.022 16.0582 10.0182C16.0195 10.0148 15.9805 10.0148 15.9418 10.0182C15.8981 10.022 15.855 10.0316 15.7686 10.0508Z",
    stroke: "#36BFFA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank32);
export default __webpack_public_path__ + "static/media/bank-32.db5fe75fe52af0ff77429b19ff68d0d8.svg";
export { ForwardRef as ReactComponent };